var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('main-visual'), _c('main-efficient'), _c('main-practice-areas'), _c('main-attorneys'), _c('main-location'), _c('popup-layer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }